import { ContactUsModal } from "./components/ContactUsModal"

const ContactUsModalConnect = () => {
  return (
    <ContactUsModal /> 
  )
}

export default ContactUsModalConnect